export * from '<%STUDIO_SRC_DIR%>/titles/universal-hub/utils/youtube.js';